var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-without-border",attrs:{"text":"","dark":"","title":"Přijmout"},on:{"click":function($event){$event.stopPropagation();return _vm.accept($event)}}},[_vm._v(" Přijmout ")])}
var staticRenderFns = []

export { render, staticRenderFns }